import { Box, Pagination, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { IFooterData } from "../../../pages/AdminConsole/UsersAndGroups/components/GenericTable/GenericTable";

export interface IKeyDriveTable {
    headers: string[];
    body: React.ReactNode;
    needFooter: boolean;
    footerData?: IFooterData;
    currentPage?: number;
    onPageChange?: (page: number) => void;
    dataPerPage?: number;
    viewOnly?: boolean;
}

export function KeyDriveTable({
    headers,
    body,
    needFooter,
    footerData,
    currentPage,
    dataPerPage,
    onPageChange,
    viewOnly = false
}: IKeyDriveTable) {

    const { t } = useTranslation();
    
    const totalQuantity = footerData?.totalQuantity || 0;
    const showingQuantity = footerData?.showingQuantity || 0;

    const totalPages = Math.ceil(totalQuantity / (dataPerPage || 1));

    return (
        <TableContainer
            component={Paper}
            sx={{
                border: '1px solid #EAEAEA',
                borderRadius: '4px',
                boxShadow: 'none'
            }}
        >
            <Table>
                <TableHead
                    sx={{
                        height: '36px',
                        '& .MuiTableCell-root': {
                            padding: '8px 0 8px 8px',
                            marginRight: '0',
                            font: 'normal normal 600 14px/21px Segoe UI',
                            color: '#818181'
                        }
                    }}
                >
                    <TableRow>
                        {                     
                            /** 
                                Celula vazia para estruturar a ação da tabela. Em algumas será renderizado um "MoreVertIcon"
                                que nada mais é do que um meno de três pontos vertical e em outras será renderizado um 
                                checkbox.
                            */ 
                        }
                        {!viewOnly && <TableCell sx={{ padding: '0px', width: '30px' }}> </TableCell>}
                        {headers.map((h, index, list) => (
                            <TableCell 
                                key={index}
                                sx={index == list.length - 1 ? { display: "flex", justifyContent: "center", marginRight: "20px" } : {}}
                            >
                                {h}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                {    /**
                        Necessário para renderizar o conteudo de dentro da tabela. 
                        Pode variar por qualquer conteudo que haja a necessidade de renderização
                    */  
                }
                <TableBody>
                    { body }
                </TableBody>
            </Table>
            {
                /**
                    Necessário para renderizar a paginação da tabela.
                */
            }
            {needFooter && (
                <TableFooter sx={{ position: "relative", padding: "16px", display: "flex", alignItems: "center" }}>
                    <Typography sx={{ textAlign: "left", display: "flex" }}>
                        {t("AdminConsole.Showing")}
                        <Typography sx={{ fontWeight: 'bold', padding: '0 4px' }}>{showingQuantity}</Typography>
                        {footerData?.dataType} {t("AdminConsole.Of")}
                        <Typography sx={{ fontWeight: 'bold', padding: '0 4px' }}>{totalQuantity}</Typography>
                        {t("AdminConsole.Total")}
                    </Typography>
                    <Box sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
                        <Stack spacing={2}>
                            <Pagination
                                count={totalPages}
                                page={currentPage}
                                onChange={(event, page) => onPageChange ? onPageChange(page) : null}
                                sx={{
                                    '& .Mui-selected': {
                                        backgroundColor: '#E8EFF3',
                                        color: '#22638D',
                                    },
                                }}
                            />
                        </Stack>
                    </Box>
                </TableFooter>
            )}
        </TableContainer>
    )
}